import QuickAdd from '../global/QuickAdd';

export default class SearchPage {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;

    this.searchForm = this.element.querySelector('#search-page-form');
    this.searchInput = this.element.querySelector('#search_text');

    this.loadSearchPage();
    this.loadQuickAdd();
  }

  loadSearchPage = () => {
    // Remove trailing '*' character from search input.
    const removeStar = this.searchInput.value.replace(/\*$/, '');
    this.searchInput.value = removeStar;
  }

  loadQuickAdd = () => {
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
  }
}
